/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BusinessProfile =
  | 'BUYER'
  | 'SUPPLIER';

export type CustomOrderItem = {
  adjustedWeight?: number | null | undefined;
  packagingId: string;
  quantity: number;
};

export type TaskAction =
  | 'APPROVE'
  | 'CANCEL'
  | 'MODIFY'
  | 'REJECT';

export type UpdateOrderActionMutationVariables = Exact<{
  referenceId: string;
  orderId: string;
  taskAction?: Types.TaskAction | null | undefined;
  items: Array<Types.CustomOrderItem> | Types.CustomOrderItem;
  orderDeliveryDate?: string | null | undefined;
  userBusinessProfile?: Types.BusinessProfile | null | undefined;
  userCompanyId: string;
  sddPaymentDate?: string | null | undefined;
}>;


export type UpdateOrderActionMutation = { updateOrderAction: { status: string } | null };


export const UpdateOrderActionDocument = /*#__PURE__*/ gql`
    mutation UpdateOrderAction($referenceId: uuid!, $orderId: uuid!, $taskAction: TaskAction, $items: [CustomOrderItem!]!, $orderDeliveryDate: timestamptz, $userBusinessProfile: BusinessProfile, $userCompanyId: uuid!, $sddPaymentDate: timestamptz) {
  updateOrderAction(
    referenceId: $referenceId
    taskAction: $taskAction
    orderId: $orderId
    items: $items
    deliveryDate: $orderDeliveryDate
    userBusinessProfile: $userBusinessProfile
    userCompanyId: $userCompanyId
    sddTriggerDate: $sddPaymentDate
  ) {
    status
  }
}
    `;
export type UpdateOrderActionMutationFn = Apollo.MutationFunction<UpdateOrderActionMutation, UpdateOrderActionMutationVariables>;

/**
 * __useUpdateOrderActionMutation__
 *
 * To run a mutation, you first call `useUpdateOrderActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderActionMutation, { data, loading, error }] = useUpdateOrderActionMutation({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      orderId: // value for 'orderId'
 *      taskAction: // value for 'taskAction'
 *      items: // value for 'items'
 *      orderDeliveryDate: // value for 'orderDeliveryDate'
 *      userBusinessProfile: // value for 'userBusinessProfile'
 *      userCompanyId: // value for 'userCompanyId'
 *      sddPaymentDate: // value for 'sddPaymentDate'
 *   },
 * });
 */
export function useUpdateOrderActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderActionMutation, UpdateOrderActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderActionMutation, UpdateOrderActionMutationVariables>(UpdateOrderActionDocument, options);
      }
export type UpdateOrderActionMutationHookResult = ReturnType<typeof useUpdateOrderActionMutation>;
export type UpdateOrderActionMutationResult = Apollo.MutationResult<UpdateOrderActionMutation>;
export type UpdateOrderActionMutationOptions = Apollo.BaseMutationOptions<UpdateOrderActionMutation, UpdateOrderActionMutationVariables>;